var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTv = function SvgTv(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1010",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.748 70.285h299.76v178.89H27.748zm65.57 235.15h167.08v-11.3c0-5.233-2.856-7.612-8.211-7.612h-39.152v-14.154h124.83c6.426-.12 9.52-2.855 9.282-9.278V61.011c.238-9.396-4.403-12.727-12.495-12.846H18.702c-9.044-.119-11.424 3.806-11.543 11.537v202.44c.357 7.493 3.927 11.42 12.257 11.537h122.57v13.203h-40.818c-4.165.238-7.497 2.974-7.735 7.137zm84.848-47.934c3.451 0 6.188 2.855 6.188 6.185a6.144 6.144 0 0 1-6.188 6.185c-3.332 0-6.07-2.736-6.07-6.185 0-3.33 2.738-6.185 6.07-6.185"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTv);
export default ForwardRef;